import { selectCurrentPageEntities } from '@ngneat/elf-pagination';
import { createRequestDataSource } from '@ngneat/elf-requests';
import { templatesStore } from './templates.store';
import {select} from '@ngneat/elf';
import {Templates} from '@store/audits/templates/templates.model';

export const getTemplatesDataSource = createRequestDataSource({
  store: templatesStore,
  data$: () => templatesStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getTemplates',
  dataKey: 'templates',
});

export const getAuditTemplateDetailsDataSource = createRequestDataSource({
  store: templatesStore,
  data$: () => templatesStore.pipe(select((state) => state as unknown as Templates)),
  requestKey: 'getAuditTemplateDetails',
  dataKey: 'auditTemplateDetails',
});
